import React, { memo } from "react";
import { Box, Card, CircularProgress, IconButton, Stack, Typography } from "@mui/material";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import TvIcon from "@mui/icons-material/Tv";
import CampaignIcon from "@mui/icons-material/Campaign";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { colaSinNombre } from "../../helpers/colas";

// Botón de acción de una tarjeta; llama al callback con la cola completa
const BotonAccion = ({ label, icon, onClick, cola, disabled = false }) => (
    <IconButton
        size="small"
        aria-label={`${label} ${cola.nombre || ""}`.trim()}
        title={label}
        disabled={disabled}
        onClick={() => onClick(cola)}
    >
        {icon}
    </IconButton>
);

/**
 * Vista móvil de la lista de colas (tarjetas). Los callbacks reciben la cola
 * completa, la misma firma que generateColaColumns, para pasar los mismos
 * handlers a las dos vistas.
 */
const ColasMobileList = ({ colas, loading, onRegistro, onPantalla, onGestor, onEditar, onEliminar }) => {
    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                <CircularProgress sx={{ color: "#cc071e" }} />
            </Box>
        );
    }

    if (!colas?.length) {
        return (
            <Typography variant="body2" sx={{ color: "#6c757d", textAlign: "center", py: 4 }}>
                No hay colas creadas
            </Typography>
        );
    }

    return (
        <Stack spacing={2}>
            {colas.map((cola) => (
                <Card key={cola.id} sx={{ p: 2, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#212529", mb: 1 }}>
                        {cola.nombre || "-"}
                    </Typography>
                    <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                        <BotonAccion label="Registro" icon={<HowToRegIcon fontSize="small" />} onClick={onRegistro} cola={cola} disabled={colaSinNombre(cola)} />
                        <BotonAccion label="Pantalla" icon={<TvIcon fontSize="small" />} onClick={onPantalla} cola={cola} disabled={colaSinNombre(cola)} />
                        <BotonAccion label="Gestor" icon={<CampaignIcon fontSize="small" />} onClick={onGestor} cola={cola} disabled={colaSinNombre(cola)} />
                        <BotonAccion label="Editar" icon={<EditIcon fontSize="small" />} onClick={onEditar} cola={cola} />
                        <BotonAccion label="Eliminar" icon={<DeleteIcon fontSize="small" />} onClick={onEliminar} cola={cola} />
                    </Stack>
                </Card>
            ))}
        </Stack>
    );
};

export default memo(ColasMobileList);
